import ValidationHelper from './ValidationHelper';
var isValid = ValidationHelper.isValid;
import ValidationMessages from './ValidationMessages';
export var getMessage = function getMessage(type, field) {
  return ValidationMessages.getValidationMessage(type, field);
};

/**
 * Validate a single field.  if it's valid, return true. Otherwise, return the error.
 * @param {object} options containing the fieldName, value, validations, trim, and length
 * @returns {object} - an object containing the field name, value, and error
 */
export var validateField = function validateField(_ref) {
  var fieldName = _ref.fieldName,
    value = _ref.value,
    validations = _ref.validations,
    _ref$trim = _ref.trim,
    trim = _ref$trim === void 0 ? false : _ref$trim,
    length = _ref.length;
  //trim white space for field values
  var fieldValue = trim ? value.trim() : value;
  var response = {
    name: fieldName,
    value: fieldValue,
    error: ''
  };

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!validations || validations.length === 0) {
    return response;
  }
  for (var i in validations) {
    var validationType = validations[i];
    if (!isValid(fieldValue, validationType, length)) {
      response = {
        name: fieldName,
        value: fieldValue,
        error: getMessage(validationType, fieldName)
      };
      break;
    }
  }
  return response;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/business/validators/ValidationField.js
// module id = 1378
// module chunks = 11